import { TZDate } from '@date-fns/tz';
import {
  isTimeInBrowserSettings,
  type ServiceLocation,
} from '../helpers/appHelper';

interface TimeZoneState {
  timeZoneTextInfo: string;
  currentTimeZone: string;
}

const getStoreTimeZoneText = (storeTimeZone: string): string => {
  try {
    const timeZoneName = new TZDate(new Date(), storeTimeZone)
      .toString()
      .match(/\(([^)]+)\)$/)?.[1];

    if (!timeZoneName) return '';

    const timeZoneAbbreviation = timeZoneName
      .split(' ')
      .map((item) => item[0])
      .join('');

    return `${timeZoneName} (${timeZoneAbbreviation})`;
  } catch {
    return '';
  }
};

export const timeZoneHelper = (
  location: ServiceLocation,
  t: (a: string) => string,
  appConfig: typeof CSS_CONFIG,
  storeTimeZone = '',
): TimeZoneState => {
  const multipleTimeZones = appConfig.multipleTimezones;
  const isBrowserTimeZone = isTimeInBrowserSettings(location, appConfig);
  const localTimeZone = isBrowserTimeZone
    ? new Date()
        .toString()
        .replace(/^.*GMT.*\(/, '')
        .replace(/\)$/, '')
    : '';

  const localTimeZoneAbbreviation =
    localTimeZone.indexOf(' ') >= 0 &&
    isTimeInBrowserSettings(location, appConfig)
      ? localTimeZone
          .split(' ')
          .map((item) => item[0])
          .join('')
      : '';

  const timeZoneAbbr = localTimeZoneAbbreviation
    ? `(${localTimeZoneAbbreviation})`
    : '';
  const storeTimeZoneText = getStoreTimeZoneText(storeTimeZone);

  const timeZoneTextInfo =
    multipleTimeZones && isBrowserTimeZone
      ? `${t(
          'components.timePicker.showingTimeZone',
        )} ${localTimeZone} ${timeZoneAbbr}`
      : multipleTimeZones && location === 'storeRemote' && storeTimeZoneText
        ? `${t('components.timePicker.showingTimeZone')} ${storeTimeZoneText}`
        : '';

  const currentTimeZone = multipleTimeZones
    ? localTimeZoneAbbreviation || localTimeZone
    : '';

  return {
    timeZoneTextInfo,
    currentTimeZone,
  };
};
